import PropTypes from 'prop-types';
import styled, { useTheme } from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Card } from '@hivebrite/design-system/Card';
import { Divider as BaseDivider } from '@hivebrite/design-system/Divider';
import { Image } from '@hivebrite/design-system/Image';
import { CheckboxInput } from '@hivebrite/design-system/Inputs';

import { Price } from 'hb-react/shared/components/Price';

const Label = ({ addon }) => (
  <LabelWrapper>
    {addon.name} - (<Price price={addon.price} currency={addon.currency} />)
  </LabelWrapper>
);

const Addon = ({ addon }) => {
  const theme = useTheme();
  const { onSelect, selected } = addon;

  return (
    <CheckboxWrapper data-testid="addon-checkbox">
      <Box mr={2} alignItems="flex-start">
        <CheckboxInput
          value={selected}
          onChange={() => onSelect(addon)}
          hideLabel
          label=""
          ariaDescribedBy={`addon-${addon.id}`}
        />
      </Box>
      <Box flexGrow={1} flexDirection="column">
        <Box
          flexGrow={1}
          flexDirection={{ _: 'column', m: 'row' }}
          justifyContent="space-between"
        >
          <Box
            flexGrow={1}
            flexDirection="column"
            onClick={() => onSelect(addon)}
            data-testid={`addon-${addon.id}`}
            id={`addon-${addon.id}`}
          >
            <Label addon={addon} />
            {addon.description && (
              <Box fontStyle="italic" color={theme.colors.dove} mt={1}>
                {addon.description}
              </Box>
            )}
          </Box>

          {addon.image && (
            <Box ml={{ _: 0, m: 4 }} mr={4} mt={{ _: 3, m: 0 }}>
              <Image
                src={addon.image}
                thumb={addon.thumb}
                width={92}
                height={92}
              />
            </Box>
          )}
        </Box>
      </Box>
    </CheckboxWrapper>
  );
};

export const Addons = ({ addons = [] }) =>
  addons.length > 0 ? (
    <Card bg="white" pt={4}>
      <Box font="h3-semibold">{__('Additional Items')}</Box>
      <Divider mt={3} />
      <Box flexDirection="column">
        {addons.map((addon, index) => (
          <Box key={`addon-${addon.id}`} flexDirection="column">
            <Addon addon={addon} />
            {index + 1 < addons.length && <Divider />}
          </Box>
        ))}
      </Box>
    </Card>
  ) : null;

Addons.propTypes = {
  addons: PropTypes.arrayOf(
    PropTypes.shape({
      onSelect: PropTypes.func.isRequired,
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      description: PropTypes.string,
      price: PropTypes.number.isRequired,
      quantity: PropTypes.number.isRequired,
      currency: PropTypes.shape({
        code: PropTypes.string.isRequired,
      }).isRequired,
      image: PropTypes.string,
      thumb: PropTypes.string,
    }),
  ),
};

const LabelWrapper = styled(Box).attrs({
  fontWeight: 1,
})`
  padding-top: 1px;
`;

const Divider = styled(BaseDivider).attrs({
  borderBottomColor: '#cdcdcd',
  width: '100%',
})``;

const CheckboxWrapper = styled(Box)`
  cursor: pointer;
`;
